import Sprite from "../component/sprite";
import Text from "../component/text";
import Shape from "../component/shape";
import NineSlice from "../component/nineSlice";
import Component from "../core/component";
import TilingSprite from "../component/tilingSprite";

export const renderTypeComps: string[] = [
    Sprite.Name, Text.Name, Shape.Name, NineSlice.Name, TilingSprite.Name,
];